// Modules
import { createSelector } from '@reduxjs/toolkit'

// Store
import selfSelector from './self'

export const currencyListSelector = createSelector(selfSelector, (self) => self.currencyList)

export const currencyListLoadingSelector = createSelector(
  selfSelector,
  (self) => self.currencyListLoading,
)

export const currencyMapSelector = createSelector(selfSelector, (self) => self.currencyMap)

export const intervalGraphValueSelector = createSelector(
  selfSelector,
  (self) => self.intervalGraphValue,
)

// New logic
export const openPanelGroupIdSelector = createSelector(
  selfSelector,
  (self) => self.openPanelGroupId,
)

export const openPanelGroupListSelector = createSelector(
  selfSelector,
  (self) => self.openPanelGroupList,
)

export const accordionTitlesListSelector = createSelector(
  selfSelector,
  (self) => self.accordionTitlesList,
)

export const currencyListUpdatedSelector = createSelector(
  selfSelector,
  (self) => self.currencyListUpdated,
)

// export const currentActiveCurrencySelector = createSelector(
//   selfSelector,
//   (self) => self.currentActiveCurrency,
// )
